export interface IFormPersonalInformation {
  name: string;
  lastname: string;
  indicator: string;
  phone: string;
  country_id: string | number;
  acceptTerms: boolean;
  province: string;
  district: string;
  canton: string;
  documentNumber: string;
  zipCode: string;
}
export interface IFormErrorsPersonalInformation {
  name?: string;
  lastname?: string;
  indicator?: string;
  phone?: string;
  country_id?: string;
  acceptTerms?: string;
  province?: string;
  district?: string;
  canton?: string;
  documentNumber?: string;
  zipCode?: string;
}

export const enum CountryCode {
  co = 'CO',
  cr = 'CRC',
  pr = 'PR',
  pty = 'PAN',
}
